import React from 'react';
import T from 'prop-types';

const StateRequestSubmitted = ({ firstName, email }) => (
  <div className="press-register-status press-register-status--success">
    <div className="press-register-status__icon press-register-status__icon--success">
      <i className="hicon-check-thin" />
    </div>
    <h1 className="press-register-status__title">Request submitted</h1>
    <p className="press-register-status__subtitle">
      Thanks{firstName ? `, ${firstName}` : ''}. We&apos;ve received your request and will be in
      touch at {email || 'your email'} once it&apos;s been reviewed.
    </p>
    <div className="press-register-status__info">
      Access requests are reviewed manually. There&apos;s no set timeline, but if you don&apos;t
      hear back within a few business days, follow up with your Apptopia press contact.
    </div>
  </div>
);

StateRequestSubmitted.propTypes = {
  firstName: T.string,
  email: T.string,
};

StateRequestSubmitted.defaultProps = {
  firstName: '',
  email: '',
};

export default StateRequestSubmitted;
